import { has } from 'lodash';
import * as types from './types';

const INITIAL_STATE = {
  data: {},
  fetching: false,
  fetchError: null,
};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.CONTROL_INFO_FETCHING:
      return {
        ...state,
        fetching: payload,
      };

    case types.CONTROL_INFO_FETCHED:
      return {
        ...state,
        data: payload,
      };

    case types.CONTROL_INFO_FETCH_ERROR:
      if (has(payload, 'response.data.Errors')) {
        const fetchError = payload.response.data.Errors[0];

        return {
          ...state,
          fetchError,
        };
      }

      return {
        ...state,
        fetchError: {
          Title: 'Error',
          Message:
            'An error occurred while retrieving Control Info. Please try again',
        },
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/state/controlInfo/reducer.js